import type {ExtractPropsWithoutRef} from '@/types';

import {Container} from '@/components/ShowMoreButton/components/Container';
import {Indicator} from '@/components/ShowMoreButton/components/Indicator';

type Props = ExtractPropsWithoutRef<typeof Container>;

export const ShowMoreButton: React.FunctionComponent<Props> = ({
  children,
  ...restProps
}) => {
  return (
    <Container {...restProps} as="button" bold>
      {children}
      <Indicator />
    </Container>
  );
};
